import { render, staticRenderFns } from "./ContatoRow.vue?vue&type=template&id=4192809a&"
import script from "./ContatoRow.vue?vue&type=script&lang=js&"
export * from "./ContatoRow.vue?vue&type=script&lang=js&"
import style0 from "./ContatoRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports